export default function toText() {
  return this.fragment.toString(false);
}
